import { Dialog, DialogContent, DialogTitle, DialogActions, Icon } from "@mui/material";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React, { useEffect, useState } from "react";
import { get } from "utils/WebService";

export default function SolicitacaoTreeModal({ open, onClose, solicitacao }) {
    // Para simplificar, a ramificação vai buscar do Pai até o filho
    const [tree, setTree] = useState([]);
    
    useEffect(() => {
        if (solicitacao && solicitacao.id) {
             get(`/solicitacoes/arvore/${solicitacao.id}`).then(res => {
                 let arr = Array.isArray(res) ? res : (res.list || []);
                 let mapLvl = {};
                 let t = arr.map((item, index) => {
                     let lvl = 0;
                     if (item.idSolicitacaoPai && mapLvl[item.idSolicitacaoPai] !== undefined) {
                         lvl = mapLvl[item.idSolicitacaoPai] + 1;
                     }
                     mapLvl[item.id] = lvl;
                     return {
                        criador: item.nomeUsuarioCriador || "Desconhecido", 
                        responsavel: item.nomeUsuarioResponsavel || "Desconhecido", 
                        id: item.id, 
                        status: item.status,
                        level: lvl
                     };
                 });
                 setTree(t);
             }).catch(() => {
                 // Fallback em caso de erro //
                 setTree([{ 
                     criador: solicitacao.nomeUsuarioCriador || "Desconhecido", 
                     responsavel: solicitacao.nomeUsuarioResponsavel || "Desconhecido", 
                     id: solicitacao.id, 
                     status: solicitacao.status,
                     level: 0 
                 }]);
             });
        }
    }, [solicitacao]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle display="flex" justifyContent="space-between" alignItems="center">
                <MDTypography variant="h6">Rastreamento da Solicitação</MDTypography>
                {solicitacao && (
                    <MDTypography variant="button" color="text" fontWeight="bold">
                        Status Atual: {solicitacao.status === 1 ? 'Concluída' : solicitacao.status === 2 ? 'Agendada' : 'Pendente'}
                    </MDTypography>
                )}
            </DialogTitle>
            <DialogContent>
                <MDBox p={2} display="flex" flexDirection="column" gap={0.5}>
                    {tree.map((node, index) => (
                        <MDBox 
                            key={index} 
                            display="flex" 
                            alignItems="flex-start"
                            flexDirection="column"
                            sx={{ pl: node.level * 3, mb: index === 0 ? 0 : 0.5 }}
                        >
                            {index === 0 && (
                                <MDTypography variant="button" fontWeight="bold" color="dark">
                                    Solicitado por: <MDTypography variant="button" fontWeight="regular">{node.criador}</MDTypography>
                                </MDTypography>
                            )}
                            <MDBox display="flex" alignItems="center" mt={0.5}>
                                <Icon sx={{ color: "#1A73E8", fontSize: "18px", mr: 1, ml: index === 0 ? 2 : 0 }}>subdirectory_arrow_right</Icon>
                                <MDTypography variant="button" fontWeight="bold" color="dark">
                                    Solicitado à: <MDTypography variant="button" fontWeight="regular">{node.responsavel}</MDTypography>
                                </MDTypography>
                                <MDBox ml={2}>
                                    <MDTypography variant="caption" fontWeight="bold" color={node.status === 1 ? "success" : node.status === 2 ? "info" : "warning"}>
                                        [{node.status === 1 ? 'Concluída' : node.status === 2 ? 'Agendada' : 'Pendente'}]
                                    </MDTypography>
                                </MDBox>
                            </MDBox>
                        </MDBox>
                    ))}
                </MDBox>
            </DialogContent>
            <DialogActions>
                <MDButton color="secondary" onClick={onClose}>
                    Fechar
                </MDButton>
            </DialogActions>
        </Dialog>
    );
}
